var map = {
	"./2015-08-20T223408Z_1_LYNXNPEB7J115_RTROPTP_4_MICROSOFT-LAUNCH-WINDOWS-10.jpg": 1055,
	"./2015-08-20T223408Z_1_LYNXNPEB7J115_RTROPTP_4_MICROSOFT-LAUNCH-WINDOWS-10.webp": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;